export default function () {
    const url = new URL(window.location.href)
    const query = Object.fromEntries(url.searchParams.entries())

    if (query.coupon) {
        const store = window.addiesaas.store

        const code = query.coupon

        const discounts = Object.values(store.getters['Shop/Orders/Cart/cartDiscounts'])
        const couponDiscount = discounts.find(discount => discount.type == 'coupon' && discount.payload.options.code == code)
    
        if (couponDiscount) {
            store.dispatch('Shop/Orders/Cart/removeCartDiscount', couponDiscount)
        }

        const discount = {
            title: code,
            type: 'coupon',
            payload: {
                type: 'coupon',
                options: {
                    code,
                },
            },
        }

        if (query.coupon_user) {
            discount.payload.options.user_id = query.coupon_user
        }

        store.dispatch('Shop/Orders/Cart/addDiscount', discount)
    }
}
